module.exports = __webpack_public_path__ + "static/media/orderoneitem.33eece7a.mp3";